import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser } from '../../helpers/lib/axios';
import { getValidToken } from '../../helpers/lib/jwt';
import LoadingSpinner from '../LoadingSpinner';

/**
 * Renders its children only for signed-in users (and, with `adminOnly`, only for admins).
 * This is a UX guard; the API must still enforce authorization on every admin endpoint.
 */
export default function RequireAuth({ adminOnly = false, children }) {
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (!getValidToken()) {
      navigate('/signup', { replace: true });
      return;
    }
    if (!adminOnly) {
      setAllowed(true);
      return;
    }

    let cancelled = false;
    getUser()
      .then((res) => {
        if (cancelled) return;
        if (res?.data?.isAdmin) {
          setAllowed(true);
        } else {
          navigate('/', { replace: true });
        }
      })
      .catch(() => {
        if (!cancelled) navigate('/signup', { replace: true });
      });

    return () => {
      cancelled = true;
    };
  }, [adminOnly, navigate]);

  if (!allowed) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }
  return children;
}
